export default __webpack_public_path__ + "static/media/icon-stop-circle.19b84532.svg";